import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
//import "emun.order/backorders/picker/order-picker-table.htm";
import tableTemplate from "emun.order/backorders/picker/backorder-picker-table.htm";
import PrintOrderOptions from "emun.order/order-print";

export const dateRanges = [
	{
		id: "All",
		title: "All"
	},
	{
		id: "Today",
		title: "Today"
	},
	{
		id: "WTD",
		title: "Week to Date"
	},
	{
		id: "LW",
		title: "Last Week"
	},
	{
		id: "MTD",
		title: "Month to Date"
	},
	{
		id: "LM",
		title: "Last Month"
	},
	{
		id: "Last30",
		title: "Last 30 Days"
	},
	{
		id: "QTD",
		title: "Quarter to Date"
	},
	{
		id: "YTD",
		title: "Year to Date"
	},
	{
		id: "Last365",
		title: "Last 12 Months"
	}
];

export const views = {
	table: "table",
	//  cards: "th-large"
};

export const sortOptions = {
	Id: "Order #: Low to High",
	"-Id": "Order #: High to Low",
	"Status,-Id": "Status: A to Z",
	"-Status,-Id": "Status: Z to A",
	"PurchaseOrder,-Id": "PO #: Low to High",
	"-PurchaseOrder,-Id": "PO #: High to Low",
	"VendorLabel,-Id": "Vendor: A to Z",
	"-VendorLabel,-Id": "Vendor: Z to A",
	"CompanyName,-Id": "Customer: A to Z",
	"-CompanyName,-Id": "Customer: Z to A",
	"OrderedOn,-Id": "Order Date: Newest",
	"-OrderedOn,-Id": "Order Date: Oldest",
	"ShipOn,-Id": "Ship Date: Newest",
	"-ShipOn,-Id": "Ship Date: Oldest",
	"GrandTotal,-Id": "Amount: Low to High",
	"-GrandTotal,-Id": "Amount: High to Low",
};

export default class BackOrderPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setOrderIds();
		$ctrl.query = new AutoQuery($ctrl.getOrdersQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		$ctrl.tableTemplate = tableTemplate;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `emun.order/backorders/picker/backorder-picker-table.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setOrderIds();
	}
	clearAll() {
		this.selected = {};
		this.setOrderIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(order) {
		return !!this.selected[order.id];
	}

	setOrderIds() {
		this.orderIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { orderIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(order) {
		const $ctrl = this;
		console.log("toggle", order.id, $ctrl.selected, order);

		if ($ctrl.single) {
			$ctrl.$close(order);
		} else if (order.id in $ctrl.selected) {
			delete $ctrl.selected[order.id];
			$ctrl.onOrderUnSelected &&
				$ctrl.onOrderUnSelected({ $order: order, ...$ctrl });
		} else {
			$ctrl.selected[order.id] = true;
			$ctrl.onOrderSelected &&
				$ctrl.onOrderSelected({ $order: order, ...$ctrl });
		}
		this.setOrderIds();
	}
	select(order) {
		const $ctrl = this;
		$ctrl.$close([order]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	printOrder() {
		const $ctrl = this;
		return PrintOrderOptions({
			request: {
				id: $ctrl.orderIds.join(','),
				IncludeImages: false,
				IncludeBarcodes: false,
				OrderBy: "strProductID"
			}
		});
	}

	export() {
		const $ctrl = this;
		var url = "/service/QueryBackorderItems.xlsx?Template=BackorderItems&Origin=A2&OrderIds=" + $ctrl.orderIds.join(',');
		return location.href = url;
	}

	getOrdersQueryOptions() {
		const $ctrl = this;
		var filters = [];
		orderConfig.filters.forEach(function (obj) {
			filters.push(obj);
		});
		return {
			url: "QueryCarts.json?IncludeProducts=1",
			orderBy: "-OrderedOn,-Id",
			disableQueryString: !!$ctrl.disableQueryString,
			pageSize: 12,
			criteria: $ctrl.criteria,
			filters,
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			autoLoad: true,
			sortOptions: {
				Id: "Order #: Low to High",
				"-Id": "Order #: High to Low",
				"Status,-Id": "Status: A to Z",
				"-Status,-Id": "Status: Z to A",
				"PurchaseOrder,-Id": "PO #: Low to High",
				"-PurchaseOrder,-Id": "PO #: High to Low",
				"VendorLabel,-Id": "Vendor: A to Z",
				"-VendorLabel,-Id": "Vendor: Z to A",
				"CompanyName,-Id": "Customer: A to Z",
				"-CompanyName,-Id": "Customer: Z to A",
				"OrderedOn,-Id": "Order Date: Newest",
				"-OrderedOn,-Id": "Order Date: Oldest",
				"ShipOn,-Id": "Ship Date: Newest",
				"-ShipOn,-Id": "Ship Date: Oldest",
				"GrandTotal,-Id": "Amount: Low to High",
				"-GrandTotal,-Id": "Amount: High to Low",
			}
		};
	}
}


